export default __webpack_public_path__ + "static/media/011_photo.5b593ee8.jpg";